import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { SectionLink } from "scmp-app/components/content/content-sections/styles";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ActionBarContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const ActionBar = styled.div`
  position: relative;

  padding-inline-end: 9.4px;

  &::after {
    position: absolute;
    inset-block-start: 50%;
    inset-inline-end: 0;
    content: "|";

    color: #727272;

    transform: translateY(-50%);
  }

  time {
    color: #727272;
    font-weight: 400;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    line-height: normal;
  }
`;

export const Section = styled.div`
  ${SectionLink} {
    color: #333333;
    font-weight: 500;
    font-size: 12px;
    font-family: ${fontRobotoCondensed};
    text-transform: uppercase;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  color: #000000;
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 15px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;
